import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import "./assets/scss/style.scss";
import App from "./App";
import "./i18next";
import { Loader } from "./components";
import store from "./redux/store";
import { Provider } from "react-redux";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ToastContainer />
      <Suspense fallback={Loader}>
        <HelmetProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </HelmetProvider>
      </Suspense>
    </Provider>
  </React.StrictMode>
);
